import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetBI_TimelineInformation = createAsyncThunk(
  "BI_TimelineInformation/GetBI_TimelineInformation",
  async (AI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/BI_TimelineInformation/GetBI_TimelineInformation",
        {
          AI_ApplicationInformationId: AI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const EditBI_TimelineInformation = createAsyncThunk(
  "BI_TimelineInformation/UpdateBI_TimelineInformation",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/BI_TimelineInformation/UpdateBI_TimelineInformation",
        parameters
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const BI_TimelineInformation = createSlice({
  name: "BI_TimelineInformation",
  initialState: {
    BI_TimelineInformation: {},
    loadingBI_TimelineInformation: false,
    errorBI_TimelineInformation: null,


    EditBI_TimelineInformation: {},
    loadingEditBI_TimelineInformation: false,
    errorEditBI_TimelineInformation: null,

    Validation: null,
  },
  reducers: {

    SetBI_TimelineInformation: (state, action) => {
      state.BI_TimelineInformation = action.payload;
    },

    SetValidation:(state,action)=>{
      state.Validation=action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetBI_TimelineInformation.pending, (state, action) => {
        state.loadingBI_TimelineInformation = true;
        state.BI_TimelineInformation = action.payload;
        state.errorBI_TimelineInformation = null;
      })
      .addCase(GetBI_TimelineInformation.fulfilled, (state, action) => {
        state.loadingBI_TimelineInformation = false;
        state.BI_TimelineInformation = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetBI_TimelineInformation.rejected, (state, action) => {
        state.loadingBI_TimelineInformation = false;
        state.errorBI_TimelineInformation = action.payload;
      })
    /////////////////////////////////////////////////////////////////////////
    builder
      .addCase(EditBI_TimelineInformation.pending, (state, action) => {
        state.loadingEditBI_TimelineInformation = true;
        state.EditBI_TimelineInformation = action.payload;
        state.errorBI_TimelineInformation = null;
      })
      .addCase(EditBI_TimelineInformation.fulfilled, (state, action) => {
        state.loadingEditBI_TimelineInformation = false;
        state.EditBI_TimelineInformation = action.payload; // Assuming payload has the desired data
      })
      .addCase(EditBI_TimelineInformation.rejected, (state, action) => {
        state.loadingEditBI_TimelineInformation = false;
        state.errorEditBI_TimelineInformation = action.payload;
      })
  },
});
export const { SetBI_TimelineInformation,SetValidation } = BI_TimelineInformation.actions;

export default BI_TimelineInformation.reducer;
